<template>
  <div class="my-video-container">
    <video preload="metadata" ref="videoPlayer" :poster="posterImage" controls muted playsinline
      data-plyr-config='{"fullscreen": {"enabled": true, "iosNative": true}}'
      style="object-fit: contain;"></video>
    <div v-if="isPlaylist" class="video-overlay-buttons">
      <v-btn icon dark elevation="0" class="mr-3 video-previous" @click="onPreviousClick">
        <v-icon>mdi-skip-previous</v-icon>
      </v-btn>
      <v-btn icon dark elevation="0" class="ml-3 video-next" @click="onNextClick">
        <v-icon>mdi-skip-next</v-icon>
      </v-btn>
    </div>
  </div>

</template>

<script>
import Plyr from 'plyr';
import Hls from 'hls.js';
import 'plyr/dist/plyr.css';
// import { mapState } from 'vuex';
// import axios from "axios";

export default {
  data() {
    return {
      posterImage: null,
      videoList: [],
      isPlaylist: false,
      player: null,
      hls: null,
      hlsUrl: null,
      currentIdx: 0,
      showButtons: false,
      isInline: true,
    };
  },
  computed: {

  },
  methods: {
    onPreviousClick() {
      if (this.player && this.isPlaylist) {
        // this.player.playlist.previous();
        if (this.currentIdx === 0) {
          console.log('currentIdx-> first');
          return;
        } else {
          this.currentIdx--;
          //  this.setVolume();
          this.play();
        }
      }
    },
    onNextClick() {
      if (this.player && this.isPlaylist) {
        // this.player.playlist.next();
        if (this.currentIdx === this.videoList.length - 1) {
          console.log('currentIdx-> end');
          return;
        } else {
          this.currentIdx++;
          //  this.setVolume();
          this.play();
        }
      }
    },
    onJumpClick() {
      if (this.player && this.isPlaylist) {
        this.player.playlist.currentItem(2);
      }
    },
    setVolume() {
      this.$refs.videoPlayer.muted = true;
      const volumeInput = document.querySelector('input[data-plyr="volume"]');
      if (volumeInput) {
        volumeInput.value = 0;
        volumeInput.dispatchEvent(new Event('input'));
      }
    },
    play() {
      //console.log('재생 시작');
      if (this.player && this.player.media) {
        this.player.pause();
      }

      if (this.videoList[this.currentIdx].sources[0].src.indexOf('m3u8') > -1) {
        this.hlsUrl = this.videoList[this.currentIdx].sources[0].src;
      }

      if (this.hlsUrl !== null && Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(this.hlsUrl);
        this.hls.attachMedia(this.$refs.videoPlayer);
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          console.log('준비 완료');
          this.$refs.videoPlayer.play();
          this.setVolume();
        });
      }
    },
  },
  async mounted() {
    /*
      /wowza/content/ 밑에 mp4파일이 있다
      

    
    
    */

    const types = { mp4: 'video/mp4', webm: 'video/webm', m3u: 'application/x-mpegURL' };
    const frontPreUrl = window.location.protocol + '//' + window.location.host;

    const localurl = window.location.href;
    // console.log("localurl : ", localurl)

    const tmpNumber = localurl.replace(frontPreUrl + '/play?', '');
    
    const arr = tmpNumber.split(',');
    this.isPlaylist = arr.length > 1;

    for (let i = 0; i < arr.length; i++) {
      const add = {
        sources: [{
          src: decodeURIComponent(arr[i]),
          type: types.m3u
        }],
      };
      this.videoList.push(add);
    }
  
    this.player = new Plyr(this.$refs.videoPlayer, {
      debug: false,
      fullscreen: { enabled: true, fallback: true, iosNative: true },
    });

    this.player = new Plyr(this.$refs.videoPlayer, {
      debug: false,

      // 음소거 제거 설정
      // muted: true,
      // autoplay: true,
      fullscreen: { enabled: true, fallback: true, iosNative: true, },
    });
   

    // 음소거 제거 설정
    this.$refs.videoPlayer.muted = false;
    this.player.muted = false; 
    this.$refs.videoPlayer.removeAttribute('muted');
    const volumeInput = document.querySelector('input[data-plyr="volume"]');
    if (volumeInput) {
      volumeInput.value = 1;
      volumeInput.dispatchEvent(new Event('input'));
    } 


    this.player.source = this.videoList;

    for (let i = 0; i < this.videoList.length; i++) {
      if (this.videoList[i].sources[0].src.indexOf('m3u8') > -1) {
        this.hlsUrl = this.videoList[i].sources[0].src;
        this.currentIdx = i;
        break;
      }
    }

    if (this.hlsUrl !== null && Hls.isSupported()) {
      this.hls = new Hls();
      this.hls.loadSource(this.hlsUrl);
      this.hls.attachMedia(this.$refs.videoPlayer);
      this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
        // this.$refs.videoPlayer.play();
      });
    } 
    else if (this.$refs.videoPlayer.canPlayType('application/vnd.apple.mpegurl')) {
        const video = this.$refs.videoPlayer;
        video.src = this.hlsUrl;
        video.addEventListener('canplay', function () {
          // video.play();
        });
    }
  },
  beforeDestroy() {
    if (this.hls) {
      this.hls.destroy();
    }
    if (this.player) {
      this.player.destroy();
    }
  }
};
</script>

<style>
.my-video-container .plyr {
  height: 100%;
  /* 또는 원하는 높이로 지정 */
  width: 100%;

}

.my-video-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100vh;
  /* 수정된 부분 */
  max-height: 100%;
  background-color: rgb(0, 0, 0);
  z-index: 1;
}

.my-video-container video {
  width: 100%;
}

.plyr video {
  height: 100% !important;
}

.video-overlay-buttons {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  visibility: hidden;
  background: transparent;
  box-shadow: none;
}

.v-btn:before {
  background-color: none;
}

.my-video-container:hover .video-overlay-buttons {
  visibility: visible;
}

.video-previous,
.video-next {
  position: static;
  flex: 0 0 auto;
}

.v-btn.icon {
  height: 50px;
  width: 50px;
  box-shadow: none;
  background: transparent;
}

.v-icon {
  font-size: 24px;
}

.video-overlay-buttons::before,
.video-overlay-buttons::after {
  content: none;
  background: transparent;
}

.video-previous:hover,
.video-next:hover {
  background: transparent;
  box-shadow: none;
}
</style>
